import React, { useState } from "react";
import styles from "./style.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../state";
import { isEqual } from "lodash";
import {
  QueryLogsByDateRange,
  QueryLastNLogs,
} from "../../../utils/graphql/hooks/adminHooks";
import { setLogDateRange } from "../../../state/adminReducer";

export default function LogConsole() {
  const dispatch = useDispatch();
  const logs = useSelector((state: RootState) => state.admin?.logs, isEqual);
  const queryLogsByDateRange = QueryLogsByDateRange();
  const queryLastNLogs = QueryLastNLogs();

  const [filterText, setFilterText] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const handleDateRangeQuery = (start: string, end: string) => {
    queryLogsByDateRange(
      start === "" ? 0 : new Date(start).getTime(),
      end === "" ? Infinity : new Date(end).getTime(),
    );
  };

  const sortedLogs = logs
    ?.slice()
    .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());

  const filteredLogs = sortedLogs?.filter((log) =>
    log.message.toLowerCase().includes(filterText.toLowerCase()),
  );

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        Log Console
        <div className={styles.filters}>
          <button
            className={styles.resetButton}
            onClick={() => {
              setStartDate("");
              setEndDate("");
              dispatch(setLogDateRange({ start: 0, end: Infinity }));
              queryLastNLogs(500);
            }}
          >
            Grab Last 500
          </button>
          <input
            type="datetime-local"
            className={styles.filterInput}
            value={startDate}
            onChange={(e) => {
              setStartDate(e.target.value);
              dispatch(
                setLogDateRange({
                  start:
                    e.target.value === ""
                      ? 0
                      : new Date(e.target.value).getTime(),
                  end: endDate === "" ? Infinity : new Date(endDate).getTime(),
                }),
              );
              handleDateRangeQuery(e.target.value, endDate);
            }}
          />
          <input
            type="datetime-local"
            className={styles.filterInput}
            value={endDate}
            onChange={(e) => {
              setEndDate(e.target.value);
              dispatch(
                setLogDateRange({
                  start: startDate === "" ? 0 : new Date(startDate).getTime(),
                  end:
                    e.target.value === ""
                      ? Infinity
                      : new Date(e.target.value).getTime(),
                }),
              );
              handleDateRangeQuery(startDate, e.target.value);
            }}
          />
          <input
            type="text"
            placeholder="Filter logs..."
            value={filterText}
            onChange={(e) => setFilterText(e.target.value)}
            className={styles.filterInput}
          />
        </div>
      </div>
      <div className={styles.logContainer}>
        <table className={styles.logTable}>
          <tbody>
            {filteredLogs?.length ? (
              filteredLogs.map((log, index) => {
                const { date, type, message } = log;
                return (
                  <tr key={index} className={styles.logEntry}>
                    <td className={styles.timestamp}>
                      {new Date(date).toLocaleString()}
                    </td>
                    <td className={styles.level}>
                      {type && (
                        <span className={styles[`level${type.toLowerCase()}`]}>
                          {type === "WARNING" ? "WARN" : type}
                        </span>
                      )}
                    </td>
                    <td className={styles.message}>{message}</td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={3} className={styles.logEntry}>
                  No logs available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
